export default "__VITE_ASSET__BhugBBDk__"